__webpack_require__.p = "https://assets.canny.io/f8c9e1e036bf1142efe7a88170cf6e7a145d1992/";